// frontend/src/utils/notificationSound.js

let lastSpecialAt = 0;                // when a special (new-trade) sound last played
const SPECIAL_SUPPRESS_MS = 700;      // suppress general for ~0.7s after special

// Reuse audio instances (keeps them "gesture-unlocked" in browsers)
const newTradeAudio =
  typeof Audio !== 'undefined' ? new Audio('/sounds/newTrade.mp3') : null;
const generalAudio =
  typeof Audio !== 'undefined' ? new Audio('/sounds/general.mp3') : null;

[newTradeAudio, generalAudio].forEach(a => {
  if (!a) return;
  a.preload = 'auto';
  a.volume = 1.0;
});

const safePlay = (audio) => {
  if (!audio) return;
  try {
    audio.currentTime = 0;
    const p = audio.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  } catch {}
};

export const playNewTradeSound = () => {
  console.log('🔔 Playing New Trade Sound');
  lastSpecialAt = Date.now();
  safePlay(newTradeAudio);
};

export const playGeneralNotificationSound = () => {
  if (Date.now() - lastSpecialAt < SPECIAL_SUPPRESS_MS) {
    console.log('🔔 Skipping general sound (new-trade just played)');
    return;
  }
  console.log('🔔 Playing General Notification Sound');
  safePlay(generalAudio);
};
